import { h } from '@omni-torn/ui';
import type { WebPrefs } from '@omni-torn/shared';
import { extensionPrefsChanged } from '../bridge';
import { server, session, setPrefsLocally } from '../session';

/** Change some of your preferences — only the part given (the extension follows them too). */
export async function savePrefs(patch: Partial<Pick<WebPrefs, 'history' | 'share' | 'terms' | 'shareSpies'>>): Promise<WebPrefs> {
  if (!session.me()) throw new Error('Not signed in.');
  const r = await server<{ prefs: WebPrefs }>('PUT', '/api/me/prefs', { prefs: patch });
  setPrefsLocally(r.prefs);
  extensionPrefsChanged();
  return r.prefs;
}

/**
 * About your history, when there's something to say: it's off (and where to turn it on), or it's
 * new (charts fill in as the snapshots come — hourly, in the background when the server tracks you).
 */
export function historyNote(snapshots: number): HTMLElement | null {
  const m = session.me();
  if (!m) return null;
  if (m.prefs.history === false)
    return h('p', { class: 'notice', 'data-note': 'history-off' }, 'History is off, so there are no changes or charts. ', h('a', { href: '/account#history', 'data-link': true }, 'Turn it on in Account'), '.');
  if (snapshots >= 2) return null;
  const background = m.tracking.tracked && m.tracking.status === 'ok';
  return h(
    'p',
    { class: 'notice', 'data-note': 'history-new' },
    background
      ? 'Omni-Torn keeps your history in the background — about once an hour, even when you’re away. Changes and charts fill in from here on.'
      : 'Your history fills in about once an hour while this site or the extension is open. ',
    background ? null : h('a', { href: '/account#tracking', 'data-link': true }, 'Background tracking keeps it going when they’re closed'),
  );
}
